<template>
  <div class="snackbar" v-if="active">{{ message }}</div>
</template>

<script>
export default {
    props: {
        message: String,
        active: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="scss">
$error: #ff6b6b;

.snackbar {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px;
    background: rgba($color: $error, $alpha: 1);
    color: white;
    transition: .3s;
    z-index: 99;
    width: 100%;
    text-align: center;
    border-radius: 4px;
}
</style>